// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__3oPkz","question":"Question_question__F-Ndc","description":"Question_description__3OoNJ"};